import styled from 'styled-components'

export const Container = styled.div`
  max-width: 100vw;
  width: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1001;
`
